// Package Imports
import React, { useState } from 'react';
import { BaseRecord } from '@refinedev/core';
import { useTable } from '@refinedev/antd';
import { useLocation } from 'react-router-dom';
// Project Imports
import apiEndpoint from 'core/common/apiEndPoints';
import WorkflowStatusViewUI from 'pages/workflow/WorkflowStatusViewUI';

const WorkflowStatusView = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // frequency_value comes from query params
  const rawFrequencyValue = searchParams.get('frequency_value') || '';
  const frequencyValue = rawFrequencyValue
    .replace(/\s\d{2}:\d{2}:\d{2}/g, '') // strip " HH:mm:ss" from both dates
    .trim();

  const [activeSearch, setActiveSearch] = useState('');

  const getCleanedQuery = () => {
    const params: string[] = [];

    if (activeSearch) params.push(`search=${activeSearch}`);
    if (frequencyValue) params.push(`frequency_value=${frequencyValue}`);
    return params.length ? `/?${params.join('&')}` : '/';
  };

  const cleanedQuery = getCleanedQuery();

  const { tableProps, tableQueryResult, setCurrent } = useTable({
    resource: `${apiEndpoint.getTaskWorkflowStatus}${cleanedQuery}`,
    dataProviderName: 'payoutProvider',
    queryOptions: {
      enabled: true,
      cacheTime: 0,
    },
    pagination: { mode: 'server' },
    syncWithLocation: false,
  });

  const rawResult = (tableProps?.dataSource as BaseRecord)?.results;
  const headers = rawResult?.headers || [];
  const dataSource = rawResult?.dataSource || [];
  const totalCount = (tableProps?.dataSource as BaseRecord)?.count || 0;

  const handleSearchChange = (value: string) => {
    setActiveSearch(value);
    setCurrent(1);
  };

  return (
    <WorkflowStatusViewUI
      tableProps={{
        ...tableProps,
        dataSource,
        pagination: {
          ...tableProps.pagination,
          total: totalCount,
          showSizeChanger: true,
        },
      }}
      headers={headers}
      loading={tableQueryResult?.isFetching || !!tableProps?.loading}
      onSearchChange={handleSearchChange}
      activeSearch={activeSearch}
    />
  );
};

export default WorkflowStatusView;
